import axios from "axios";
import AuthService from "../utils/AuthService";

const normalizeBaseUrl = () => {
  const rawUrl = process.env.REACT_APP_ITEMS_API_URL;

  if (typeof rawUrl !== "string") {
    return undefined;
  }

  const trimmed = rawUrl.trim();

  if (!trimmed || ["undefined", "null"].includes(trimmed.toLowerCase())) {
    return undefined;
  }

  return trimmed.replace(/\/$/, "");
};

const getBaseUrl = () => {
  const baseUrl = normalizeBaseUrl();

  if (!baseUrl) {
    throw new Error("Items API URL is not configured.");
  }

  return baseUrl;
};

const buildRequestConfig = (params = {}) => {
  const authConfig = AuthService.getAuthHeader() || {};
  const configHeaders = authConfig.headers || {};

  return {
    ...authConfig,
    params,
    headers: {
      ...configHeaders,
    },
  };
};

const fetchEnrollments = async ({
  page = 0,
  pageSize = 10,
  year,
  nextToken,
} = {}) => {
  const baseUrl = getBaseUrl();
  const params = {};

  const hasValidNextToken =
    nextToken !== undefined && nextToken !== null && `${nextToken}`.trim() !== "";

  if (hasValidNextToken) {
    params.nextToken =
      typeof nextToken === "string" ? nextToken.trim() : nextToken;
  } else if (typeof page === "number" && Number.isFinite(page)) {
    params.page = page + 1; // API pages are typically 1-based
  }

  if (typeof pageSize === "number" && Number.isFinite(pageSize)) {
    params.pageSize = pageSize;
  }

  if (year !== undefined && year !== null && `${year}`.trim() !== "") {
    params.year = year;
  }

  const response = await axios.get(
    `${baseUrl}/enrollments`,
    buildRequestConfig(params)
  );

  return response.data;
};

const fetchContactPosts = async ({
  page = 0,
  pageSize = 10,
  year,
  email,
} = {}) => {
  const baseUrl = getBaseUrl();
  const params = {};

  if (typeof page === "number" && Number.isFinite(page)) {
    params.page = page + 1;
  }

  if (typeof pageSize === "number" && Number.isFinite(pageSize)) {
    params.pageSize = pageSize;
  }

  if (year !== undefined && year !== null) {
    const yearValue = `${year}`.trim();
    if (yearValue !== "") {
      params.year = yearValue;
    }
  }

  if (email !== undefined && email !== null) {
    const emailValue = `${email}`.trim();
    if (emailValue !== "") {
      params.email = emailValue;
    }
  }

  const response = await axios.get(
    `${baseUrl}/contactposts`,
    buildRequestConfig(params)
  );

  return response.data;
};

const AuthoringAdminService = {
  fetchEnrollments,
  fetchContactPosts,
  isConfigured: () => Boolean(normalizeBaseUrl()),
};

export default AuthoringAdminService;
